import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Box, Flex, useMultiStyleConfig, useBreakpointValue } from "@chakra-ui/react";
import { XMark, XMarkVariants } from "../../../atoms";
import { getErrorXmarkSize } from "../helpers";
const XmarkVariant = ({ titleLabel, errorMessage, variant, }) => {
    const size = useBreakpointValue({
        sm: "sm",
        md: "md",
        lg: "lg",
    }, {
        fallback: "md",
    });
    const styles = useMultiStyleConfig("ErrorPage", { titleLabel, size, variant });
    return (_jsx(Box, Object.assign({ sx: styles.mainContainer, className: "error-xmark-container" }, { children: _jsxs(Flex, Object.assign({ flexDirection: "column", alignItems: "center", className: "error-xmark-center-page" }, { children: [_jsx(Flex, Object.assign({ className: "error-xmark-title", alignItems: "center", sx: styles.errorTitle }, { children: _jsx(Box, Object.assign({ className: "error-xmark-icon" }, { children: _jsx(XMark, { width: getErrorXmarkSize(size), variant: XMarkVariants.CONFIDENTLY_CORAL }) })) })), _jsx(Flex, Object.assign({ className: "error-xmark-footer", sx: styles.errorFooter }, { children: _jsx(Text, Object.assign({ as: "span" }, { children: errorMessage })) }))] })) })));
};
XmarkVariant.displayName = "XmarkVariant";
export default XmarkVariant;
//# sourceMappingURL=XmarkVariant.js.map